if (!Array.prototype.remove) {
    Object.defineProperty(Array.prototype, 'remove', {
        value(target) {
            const index = this.indexOf(target);
            if (index <= -1) {
                return false;
            }
            const removeItem = this.splice(index, 1);
            return removeItem === target;
        },
        enumerable: false,
        configurable: true,
        writable: true,
    });
}
